import * as tslib_1 from "tslib";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
import { jsonMember, jsonObject } from "typedjson";
import { PitFinancingItem } from "./pit-financing-item";
import { PitSourceActivityVersion } from "./pit-source-activity-version";
import { DxCoreUtils } from "../../dx-core/utiles/dx-core-utils";
let PitFinancingRedistributionBySource = class PitFinancingRedistributionBySource extends DxGridRow {
    constructor() {
        super(...arguments);
        /** Сумма перераспределения */
        this._redistributionSum = 0;
        this._fakeId = DxCoreUtils.randomHexaDecimal();
    }
    get financingItemId() {
        return this._financingItem ? this._financingItem.id : null;
    }
    get financingItemSrcId() {
        return this._financingItemSrc ? this._financingItemSrc.id : null;
    }
    get id() {
        return this._id ? this._id : this._fakeId;
    }
    set id(value) {
        this._id = value;
    }
    get isNew() {
        return this.id !== this._id;
    }
    getRowId() {
        return this.id;
    }
    get year() {
        return this._year;
    }
    get activityFinancingCanRedistribute() {
        return this._activityFinancingCanRedistribute;
    }
    get activityFinancingRedistributeReserve() {
        return this._activityFinancingRedistributeReserve;
    }
    get activityFinancingSum() {
        return this._activityFinancingSum;
    }
    get financingItem() {
        return this._financingItem;
    }
    get financingItemSrc() {
        return this._financingItemSrc;
    }
    set financingItemSrc(value) {
        this._financingItemSrc = value;
    }
    get activityVersion() {
        return this._activityVersion;
    }
    get kadmCode() {
        return this._financingItem.kadmCode;
    }
    get kfsrCode() {
        return this._financingItem.kfsrCode;
    }
    get kcsrCode() {
        return this._financingItem.kcsrCode;
    }
    get kvrCode() {
        return this._financingItem.kvrCode;
    }
    get kosguCode() {
        return this._financingItem.kosguCode;
    }
    get dopFkCode() {
        return this._financingItem.dopFkCode;
    }
    get dopEkCode() {
        return this._financingItem.dopEkCode;
    }
    get dopKrCode() {
        return this._financingItem.dopKrCode;
    }
    get code() {
        return this._activityVersion.activity.code;
    }
    get shortName() {
        return this._activityVersion.activity.shortName;
    }
    get versionCode() {
        return this._activityVersion.code;
    }
    get curatorId() {
        return this.activityVersion.activity.curatorId;
    }
    get redistributionSum() {
        return this._redistributionSum;
    }
    set redistributionSum(value) {
        this._redistributionSum = value;
    }
    get activityFinancingFinishSum() {
        return this._activityFinancingFinishSum;
    }
    set year(value) {
        this._year = value;
    }
    set activityFinancingCanRedistribute(value) {
        this._activityFinancingCanRedistribute = value;
    }
    set activityFinancingRedistributeReserve(value) {
        this._activityFinancingRedistributeReserve = value;
    }
    set activityFinancingSum(value) {
        this._activityFinancingSum = value;
    }
    set activityFinancingFinishSum(value) {
        this._activityFinancingFinishSum = value;
    }
    set financingItem(value) {
        this._financingItem = value;
    }
    set activityVersion(value) {
        this._activityVersion = value;
    }
    equalsToSource(el) {
        return this.activityVersion.id === el.activityVersion.id && this.financingItemSrcId === el.financingItemSrcId;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "year", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_year", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activityFinancingCanRedistribute", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_activityFinancingCanRedistribute", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activityFinancingRedistributeReserve", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_activityFinancingRedistributeReserve", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activityFinancingSum", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_activityFinancingSum", void 0);
tslib_1.__decorate([
    jsonMember({ name: "activityFinancingFinishSum", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_activityFinancingFinishSum", void 0);
tslib_1.__decorate([
    jsonMember({ name: "redistributionSum", constructor: Number, emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFinancingRedistributionBySource.prototype, "_redistributionSum", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingItem", constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitFinancingItem)
], PitFinancingRedistributionBySource.prototype, "_financingItem", void 0);
tslib_1.__decorate([
    jsonMember({ name: "financingItemSrc", constructor: PitFinancingItem, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitFinancingItem)
], PitFinancingRedistributionBySource.prototype, "_financingItemSrc", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [])
], PitFinancingRedistributionBySource.prototype, "financingItemId", null);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number),
    tslib_1.__metadata("design:paramtypes", [])
], PitFinancingRedistributionBySource.prototype, "financingItemSrcId", null);
tslib_1.__decorate([
    jsonMember({ name: "activityVersion", constructor: PitSourceActivityVersion, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitSourceActivityVersion)
], PitFinancingRedistributionBySource.prototype, "_activityVersion", void 0);
PitFinancingRedistributionBySource = tslib_1.__decorate([
    jsonObject
], PitFinancingRedistributionBySource);
export { PitFinancingRedistributionBySource };
